import React from 'react';

import { FormControl, Box, FormHelperText, TextField } from '@mui/material';

export default function SponsorStateField({
  value,
  error,
  setValue,
  setError,
  ...rest
}) {
  const handleChange = (event) => {
    const { value: newValue } = event.target;
    setValue(newValue);
    if (newValue === '') {
      setError('State cannot be blank');
    } else {
      setError(false);
    }
  };

  return (
    <Box>
      <FormControl fullWidth required>
        <TextField
          {...rest}
          label='State'
          id='state'
          aria-describedby='state-helper-text'
          onChange={handleChange}
          error={Boolean(error || value === '')}
          value={value}
          variant='standard'
          required
        />
        {error ? (
          <FormHelperText id='state-helper-text'>{error}</FormHelperText>
        ) : undefined}
      </FormControl>
    </Box>
  );
}
